import React from "react";

const TOKEN = /(https?:\/\/\S+|[\w.+-]+@[\w-]+\.[\w.-]+|\+?\d[\d\-\s]{6,}\d)/g;

/** يعرض النص العربي مع عزل الأرقام والروابط والإيميلات باتجاه LTR حتى لا تنعكس (+966 53 … تبقى مقروءة وقابلة للنسخ). */
export const LtrText = ({ text, className = "", plain = false }) => {
  const s = String(text ?? "");
  if (!s) return null;
  const parts = s.split(TOKEN);
  return (
    <span className={className} dir="auto">
      {parts.map((p, i) => {
        if (!p) return null;
        if (i % 2 === 0) return <React.Fragment key={i}>{p}</React.Fragment>;
        const isUrl = /^https?:\/\//.test(p);
        const isMail = p.includes("@");
        const digits = p.replace(/\D/g, "");
        if (!isUrl && !isMail && digits.length < 7) return <React.Fragment key={i}>{p}</React.Fragment>;
        const shown = isUrl || isMail ? p : p.replace(/[\s-]/g, "");
        const href = isUrl ? p : isMail ? `mailto:${p}` : `tel:${shown}`;
        if (plain) return <bdi key={i} dir="ltr" className="inline-block">{shown}</bdi>;
        return (
          <bdi key={i} dir="ltr" className="inline-block">
            <a href={href} target={isUrl ? "_blank" : undefined} rel="noreferrer" className="underline decoration-dotted underline-offset-2 hover:text-primary break-all" onClick={(e) => e.stopPropagation()} data-testid="ltr-token">{shown}</a>
          </bdi>
        );
      })}
    </span>
  );
};
